var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PersonSpecificExtraWorkListWeb"},[_c('v-data-table',{attrs:{"dense":"","disable-sort":false,"headers":_vm.headers,"hide-default-footer":"","disable-pagination":"","items":_vm.list},on:{"click:row":_vm.handleClick},scopedSlots:_vm._u([{key:"item.status",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(" "+_vm._s(_vm.getStatus(item.status))+" ")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }